export { default as TermsPage } from './ui/TermsPage';
